import { Injectable } from '@angular/core';

import { ComponentCanDeactivate } from './component-can-deactivate';

@Injectable()
export class CanDeactivateGuard  {
    canDeactivate(component: ComponentCanDeactivate): boolean {

        if (!component.canDeactivate()) {
            if (confirm('Cette page demande de confirmer sa fermeture ; des données saisies pourraient ne pas être enregistrées.')) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }
}